module.exports = __webpack_public_path__ + "img/melia-res.26daeba1.png";